export default {
  tipoPlanilha: {
    value: null,
    options: [],
    required: true,
    state: null
  },
  fileDetails: {
    value: null,
    required: false,
    state: null
  },
  tipoBoardCobrancaEmprestimo: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  colunaCobrancaEmprestimo: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  tipoBoardCobrancaCartao: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  colunaCobrancaCartao: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  tipoBoardCobrancaGerais: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  colunaCobrancaGerais: {
    value: null,
    options: [],
    required: false,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/import/components/add/import-form.js